<template>
  <div>
  </div>
</template>

<script>
import { MERCADO_PAYCONFIRM } from "../../apis/payment";

// Mercado Pago Checkout Pro 回跳接收页:
// 支付完成后 MP 按 back_urls 回跳至此,URL 由后端自动附加 outTradeNo&type=PreAuth,
// MP 另行附加 payment_id/status/preference_id;下单时 returnUri 携带 pt=YJ|CZ|FK 用于区分完成页
export default {
  components: {
  },
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
    onCheckoutConfirm() {
      const { outTradeNo, pt } = this.$route.query;
      if (!outTradeNo) {
        this.$router.replace("/");
        return;
      }
      // MP 收银台明确失败/取消(rejected/cancelled/failure):不回查,直接失败提示后按场景返回
      if (
        ["failure", "rejected", "cancelled"].indexOf(this.$route.query.status) >
        -1
      ) {
        this.onCheckoutFail(pt);
        return;
      }
      this.$loading(true);
      this.$get(
        MERCADO_PAYCONFIRM,
        {
          outTradeNo: outTradeNo
        },
        resp => {
          this.$loading(false);
          console.log("MercadoPago回跳确认数据===", resp);
          if (resp.data) {
            if (pt === "FK") {
              this.$toast(this.$t("msg.success_payment"));
              this.$router.replace(`/pastOrder`);
              return;
            }
            this.$router.replace(
              `/borrowSuccess?tradeNo=${resp.data.orderId}&payMode=mercaDoPaGo&loading=true`
            );
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$confirm({
            title: this.$t("msg.title"),
            content: this.$t("result.msg_fail_content"),
            confirmText: this.$t("msg.retry"),
            cancelText: this.$t("msg.cancel")
          }).then(() => {
            this.onCheckoutConfirm();
          });
        }
      );
    },
    // 失败回跳:提示后按场景返回(FK 回订单列表可再次补款,CZ 回钱包,其余回首页)
    onCheckoutFail(pt) {
      this.$confirm({
        title: this.$t("msg.title"),
        content: this.$t("msg.fail_payment"),
        confirmText: this.$t("msg.confirm"),
        showCancel: false
      }).then(() => {
        if (pt === "FK") {
          this.$router.replace(`/pastOrder`);
        } else if (pt === "CZ") {
          this.$router.replace(`/wallet`);
        } else {
          this.$router.replace(`/`);
        }
      });
    }
  },
  created () {
    this.onCheckoutConfirm();
  }
}
</script>

<style lang="less" scoped>
</style>
